const COPY_ACTION = {
  key: 'copy_conversation_to_inbox',
  label: 'COPY_CONVERSATION_TO_INBOX',
  inputType: 'search_select',
  optionsSource: 'inboxes',
};

const registerEnhancedAutomationAction = PluginSystem => {
  const extension = {
    actionsByEntity: {
      conversation: [COPY_ACTION.key],
      message: [COPY_ACTION.key],
    },
    actionTypes: [COPY_ACTION],
  };

  const automationApi = window.chatwoot?.plugins?.['automation-enhanced'];

  if (automationApi?.registerExtension) {
    automationApi.registerExtension(extension);
    return;
  }

  if (PluginSystem?.registerHook) {
    PluginSystem.registerHook('automation-enhanced:config', config => ({
      ...config,
      actionsByEntity: {
        ...config.actionsByEntity,
        conversation: [
          ...(config.actionsByEntity?.conversation || []),
          COPY_ACTION.key,
        ],
        message: [...(config.actionsByEntity?.message || []), COPY_ACTION.key],
      },
      actionTypes: [...(config.actionTypes || []), COPY_ACTION],
    }));
  }
};

export function install(_app, { PluginSystem } = {}) {
  registerEnhancedAutomationAction(PluginSystem);
}

export default { install };
